<div class="sliding-panel-overlay" [class.active]="isOpen" (click)="onClose()">
</div>

<div class="sliding-panel" [class.open]="isOpen" #panel>
  <div class="drag-handle" (mousedown)="onDragStart($event)"></div>
  <div class="panel-header">
    <h2>{{ title }}</h2>
    <button class="close-btn" (click)="onClose()">
      <i class="fas fa-angle-double-right"></i>
    </button>
  </div>
  
  <div class="panel-content">
    <ng-container #contentContainer></ng-container>
  </div>
</div> 